<template>
    <div class="col-12">
      <div class="search-padd">
      <form @change="addEvent" v-on:submit.prevent>
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading admin_heading_1 text-align-left">+/-</div>
          <div class="crm_admin_heading admin_heading_2 text-align-left">First Name</div>
          <div class="crm_admin_heading admin_heading_3 text-align-left">Last Name</div>
          <div :class="'crm_admin_heading ' + get_admin_heading_4 + ' text-align-left'">Email</div>
          <div class="crm_admin_heading admin_heading_5 text-align-left">Status</div>
          <div v-if="accountId > 0" :class="'crm_admin_heading ' + get_admin_heading_6 + ' text-align-center'">Contact</div>
          <div class="crm_admin_heading admin_heading_7 text-align-left">Title</div>
          <div v-if="accountId == 0" :class="'crm_admin_heading ' + get_admin_heading_6">&nbsp;&nbsp;</div>
          <div class="crm_admin_heading admin_heading_8 text-align-center">News</div>
          <div class="crm_admin_heading admin_heading_9 text-align-center">Billing</div>
          <div class="crm_admin_heading admin_heading_10 text-align-center">Primary</div>
          <div class="crm_admin_heading admin_heading_11 text-align-center">&nbsp;</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-for="(admin_contact, index) in admin_contacts" :key="index" :v-if="loading === false">
          <div v-bind:class="'admin_details' + index" v-bind:id="'admin_details_more' + index">
            <div class="">
              <input
                  type="hidden"
                  v-bind:name="'uid[' + index + ']'"
                  v-bind:id="'uid_' + index"
                  v-model="admin_contact.uid">
              <div
                class="crm_admin_field_lists admin_heading_1 text-align-center font-25 line-height-30">
                <a v-b-toggle="'collapse_' + index" class="cursor-pointer">
                  <span class="when-opened">-</span> <span class="when-closed">+</span>
                </a>
              </div>
              <div class="crm_admin_field_lists admin_heading_2 text-align-left">
                <div class="search-padd">
                  <input
                      type="text"
                      v-bind:id="'admin_fname_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="admin_fname"
                      v-bind:name="'admin_fname[' + index + ']'"
                      v-model="admin_contact.admin_fname"
                      v-validate="{ rules: { required: true, regex: nameRegex() } }"
                      placeholder="First Name"
                      maxlength="250"
                      autocomplete="off"
                      @keydown.enter.prevent='enterSearchAction(index)'>
                  <div v-if="verrors.firstByRule('admin_fname[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">First name is required</div>
                  <div v-if="verrors.firstByRule('admin_fname[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">First name should only contain - and _</div>
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_3 text-align-left">
                <div class="search-padd">
                  <input
                      type="text"
                      v-bind:id="'admin_lname_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="admin_lname"
                      v-bind:name="'admin_lname[' + index + ']'"
                      v-model="admin_contact.admin_lname"
                      v-validate="{ rules: { required: true, regex: nameRegex() } }"
                      placeholder="Last Name"
                      maxlength="250"
                      autocomplete="off"
                      @keydown.enter.prevent='enterSearchAction(index)'>
                  <div v-if="verrors.firstByRule('admin_lname[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Last name is required</div>
                  <div v-if="verrors.firstByRule('admin_lname[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">Last name should only contain - and _</div>
                </div>
              </div>
              <div :class="'crm_admin_field_lists ' + get_admin_heading_4 + ' text-align-left'">
                <div class="search-padd">
                  <input
                      type="text"
                      v-bind:id="'admin_email_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      ref="admin_email"
                      v-bind:name="'admin_email[' + index + ']'"
                      v-model="admin_contact.admin_email"
                      v-validate="'required|email'"
                      placeholder="Email"
                      maxlength="250"
                      autocomplete="off"
                      @keydown.enter.prevent='enterSearchAction(index)'>
                  <div v-if="verrors.firstByRule('admin_email[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
                  <div v-if="verrors.firstByRule('admin_email[' + index + ']', 'email')" class="margin-bottom-5 validate-warning-msg">Email is invalid</div>
                  <div v-if="verrors.firstByRule('admin_email[' + index + ']', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_5 text-align-left">
                <div class="search-padd">
                  <b-form-select
                      class="col-12 col-sm-12 ma-input-field"
                      v-bind:name="'admin_status[' + index + ']'"
                      v-bind:id="'admin_status_' + index"
                      v-model="admin_contact.admin_status"
                      :options="admin_status_options">
                      </b-form-select>
                </div>
              </div>
              <div v-if="accountId > 0" :class="'crm_admin_field_lists ' + get_admin_heading_6 + ' text-align-center crm_field_padding_top'">
                <div class="search-padd">
                  <button class="btn btn-sm ma-blue-btn" @click="openContactModal(index)">Contact</button>
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_7 text-align-left">
                <div class="search-padd">
                  <b-form-select
                      class="col-12 col-sm-12 ma-input-field"
                      v-bind:name="'admin_title[' + index + ']'"
                      v-bind:id="'admin_title_' + index"
                      v-model="admin_contact.admin_title"
                      :options="titlesOptions">
                      </b-form-select>
                </div>
              </div>
              <div v-if="accountId == 0" :class="'crm_admin_field_lists ' + get_admin_heading_6 + ' crm_field_padding_top'">&nbsp;&nbsp;</div>
              <div class="crm_admin_field_lists admin_heading_8 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <input
                      type="checkbox"
                      v-bind:id="'is_news_' + index"
                      ref="is_news"
                      v-bind:name="'is_news[' + index + ']'"
                      v-model="admin_contact.is_news"
                      :value="1">
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_9 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <input
                      type="radio"
                      v-bind:id="'is_billing_' + index"
                      ref="is_billing"
                      v-bind:name="'is_billing[' + index + ']'"
                      v-model="admin_contact.is_billingadmin"
                      @click="clickBillingAdmin(index)"
                      :value="1">
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_10 text-align-center crm_field_padding_top">
                <div class="search-padd">
                  <input
                      type="radio"
                      v-bind:id="'is_primaryadmin_' + index"
                      ref="is_primaryadmin"
                      v-bind:name="'is_primaryadmin[' + index + ']'"
                      v-model="admin_contact.is_primaryadmin"
                      @click="clickPrimaryAdmin(index)"
                      :value="1">
                </div>
              </div>
              <div class="crm_admin_field_lists admin_heading_11 text-align-center">
                <div
                  class="search-padd delete-icon" style=""
                  v-if="admin_contacts.length > 1">
                    <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeAdmin(index)"></i>
                </div>
              </div>
            </div>
            <div style="clear: both;"></div>

            <b-collapse v-bind:id="'collapse_' + index" class="">

              <div class="col-md-6 float-left override-padding">
                <div class="col-12">
                  <input
                      type="text"
                      v-bind:name="'id_number[' + index + ']'"
                      v-bind:id="'id_number_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.id_number"
                      placeholder="ID Number"
                      maxlength="150">
                  <input
                      type="password"
                      v-bind:name="'password[' + index + ']'"
                      v-bind:id="'password_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.password"
                      placeholder="Password"
                      v-validate="'min:6'"
                      maxlength="20"
                      role="presentation"
                      autoComplete="new-password"
                      >
                  <div v-show="verrors.has('password[' + index + ']')" class="validate-warning-msg">The password field must be at least 6 characters</div>
                  <input
                      type="text"
                      v-bind:name="'mobile[' + index + ']'"
                      v-bind:id="'mobile_' + index"
                      class="col-md-12 ma-input-field"
                      v-model="admin_contact.mobile"
                      @keyup="adminMobileValid($event, index)"
                      @blur="adminMobileValid($event, index)"
                      v-validate="{ rules: { regex: adminPhoneRegex() } }"
                      placeholder="Mobile"
                      maxlength="14">
                  <div v-if="verrors.has('mobile[' + index + ']')" class="margin-bottom-5 validate-warning-msg">Phone number is invalid</div>
                  <div class="col-12 col-md-12 override-padding">
                    <div class="col-md-9 float-left padding-lr-5" style="padding-left: 0">
                      <input
                          type="text"
                          v-bind:name="'phone[' + index + ']'"
                          v-bind:id="'phone_' + index"
                          class="col-md-12 ma-input-field"
                          v-model="admin_contact.phone"
                          @keyup="adminPhoneValid($event, index)"
                          @blur="adminPhoneValid($event, index)"
                          v-validate="{ rules: { regex: adminPhoneRegex() } }"
                          placeholder="Phone"
                          maxlength="14">
                      <div v-if="verrors.has('phone[' + index + ']')" class="margin-bottom-5 validate-warning-msg">Phone number is invalid</div>
                    </div>
                    <div class="col-md-3 float-left override-padding">
                      <input
                          type="text"
                          v-bind:name="'phone_ext[' + index + ']'"
                          v-bind:id="'phone_ext_' + index"
                          class="col-md-12 ma-input-field"
                          v-model="admin_contact.phone_ext"
                          @keyup="adminPhoneExtValid($event, index)"
                          @blur="adminPhoneExtValid($event, index)"
                          placeholder="Ext"
                          maxlength="3">
                    </div>
                  </div>

                  <div style="clear: both;"></div>
                  <div class="col-12 col-md-12 override-padding" style="float: none;  padding-top: 7px !important;" v-if="admin_contact.eula">
                    <div class="col-md-12 p-0">
                      <label class="" for="submit_comment_1" style="color: #002F42;">EULA accepted on : {{ admin_contact.eula }}</label>
                    </div>
                  </div>

                </div>
              </div>

              <div class="col-md-6 float-left override-padding">
                <div class="col-12">
                  <input
                      type="text"
                      v-bind:name="'location_name[' + index + ']'"
                      v-bind:id="'location_name_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.location_name"
                      placeholder="Location Name"
                      maxlength="250">
                  <div class="col-12 col-md-12 override-padding">
                    <div class="col-md-10 float-left override-padding">
                      <b-form-select
                          class="col-12 col-sm-12 ma-input-field"
                          v-bind:name="'country[' + index + ']'"
                          v-bind:id="'country_' + index"
                          v-model="admin_contact.country"
                          :options="country_options"
                          v-on:change="getStateLists(admin_contact.country, index)">
                          </b-form-select>
                    </div>
                    <div class="col-md-2 float-left override-padding">
                      <button
                        v-on:click="updateCountryUS(index)"
                        class="col-12 btn btn-red edit-action-btn margin-bottom-5"
                        >US</button>
                    </div>
                  </div>
                  <input
                      type="text"
                      v-bind:name="'address[' + index + ']'"
                      v-bind:id="'address_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.address"
                      placeholder="Billing Address 1"
                      maxlength="250">
                  <input
                      type="text"
                      v-bind:name="'address2[' + index + ']'"
                      v-bind:id="'address2_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.address2"
                      placeholder="Billing Address 2"
                      maxlength="250">
                  <input
                      type="text"
                      v-bind:name="'city[' + index + ']'"
                      v-bind:id="'city_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.city"
                      placeholder="Billing City"
                      maxlength="100">
                  <input
                      type="text"
                      v-bind:name="'zip[' + index + ']'"
                      v-bind:id="'zip_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.zip"
                      placeholder="Blling Zip"
                      v-validate="{ rules: { regex: adminPostalCodeRegex(index) } }"
                      maxlength="10">
                  <div v-if="verrors.firstByRule('zip[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing zip is invalid</div>
                  <b-form-select
                      class="col-12 col-sm-12 ma-input-field"
                      v-bind:name="'state[' + index + ']'"
                      v-bind:id="'state_' + index"
                      v-model="admin_contact.state"
                      :options="admin_contact.state_options">
                      </b-form-select>
                  <input
                      type="text"
                      v-bind:name="'market_area[' + index + ']'"
                      v-bind:id="'market_area_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="admin_contact.market_area"
                      placeholder="Billing Market Area"
                      maxlength="100">
                </div>
              </div>
              <div style="clear: both;"></div>

            </b-collapse>
          </div>
          <div style="clear: both;"></div>
          <div style="clear: both; margin-top: 10px;"></div>
        </div>

        <button
            v-on:click="addAdmin()"
            v-if="this.admin_contacts.length < 10"
            class="btn btn-red btn-group-sm input-height-15"
            ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>New Admin</button>

        <div style="clear: both;" class="margin-bottom-10"></div>

        <DeleteModal :isModalVisible="isDeleteModalVisible" :id="delete_id" :parent_id="parent_id" @close="isDeleteModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteAdminAction(delete_id)">Confirm</button>
          </div>
        </DeleteModal>

        <ValidationModal :isModalVisible="isInfoModalVisible" v-if="validationMessage" @close="isInfoModalVisible = false">
          <span class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">{{  validationMessage }}</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
          </div>
        </ValidationModal>

        <ContactModal 
          :isModalVisible="isContactModalVisible" 
          :id="delete_id" 
          :parent_id="parent_id" 
          @close="isContactModalVisible = false"
          ref="admin_contact_form">
        </ContactModal>

      </form>
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import DeleteModal from '../shared/delete_modal_alert.vue';
import { Validator } from "vee-validate";
import ValidationModal from '../shared/validation_modal_alert.vue';
import ContactModal from './admin_contact.vue';
import Multiselect from 'vue-multiselect';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const customTitlesOptions = [
  {value: '', text: 'Select Title'},
  {value: 'Associate Publisher', text: 'Associate Publisher'},
  {value: 'CEO', text: 'CEO'},
  {value: 'Collision Center Manager', text: 'Collision Center Manager'},
  {value: 'Content Director', text: 'Content Director'},
  {value: 'COO', text: 'COO'},
  {value: 'Director of Operations', text: 'Director of Operations'},
  {value: 'Editor', text: 'Editor'},
  {value: 'Editorial Director', text: 'Editorial Director'},
  {value: 'Executive Manager', text: 'Executive Manager'},
  {value: 'Fixed Operations Director', text: 'Fixed Operations Director'},
  {value: 'Fixed Operations Manager', text: 'Fixed Operations Manager'},
  {value: 'Front Office', text: 'Front Office'},
  {value: 'General Manager', text: 'General Manager'},
  {value: 'General Sales Manager', text: 'General Sales Manager'},
  {value: 'Group Publisher', text: 'Group Publisher'},
  {value: 'HR Director', text: 'HR Director'},
  {value: 'Managing Partner', text: 'Managing Partner'},
  {value: 'Owner/DP', text: 'Owner/DP'},
  {value: 'President', text: 'President'},
  {value: 'Service Advisor', text: 'Service Advisor'},
  {value: 'Service Manager', text: 'Service Manager'},
  {value: 'Service Operations Manager', text: 'Service Operations Manager'},
  {value: 'Technician', text: 'Technician'},
  {value: 'Vice President', text: 'Vice President'}, 
  {value: 'Prospect', text: 'Prospect'},
]

export default {
      props: ['accountId', 'accountStatus'],
      data() {
        return {
          admin_contacts: [],
          country_options: [],
          isDeleteModalVisible: false,
          parent_id: '',
          delete_id: '',
          loading: false,
          remove_data: '',
          updated_admin_contacts: {},
          isInfoModalVisible: false,
          validationMessage: '',
          titlesOptions: customTitlesOptions,
          isContactModalVisible: false,
          admin_status_options: [
            { value: '', text: 'Select Status' },
            { value: 'Active', text: 'Active' },
            { value: 'Inactive', text: 'Inactive' },
            { value: 'Prospect', text: 'Prospect' }
          ],
        }
      },
      components: {
        DeleteModal,
        ValidationModal,
        ContactModal,
        Multiselect,
      },
      computed: {
        get_admin_heading_4() {
            return (this.accountId > 0) ? "admin_heading_email" : "admin_heading_4";
        },
        get_admin_heading_6() {
            return (this.accountId > 0) ? "admin_heading_contact" : "admin_heading_6";
        },
      },
      methods: {
        nameRegex: function() {
          return /^[a-zA-Z-_ ']*$/;
        },
        addAdmin: function() {
          this.admin_contacts.push({
            uid: 0,
            admin_fname: '',
            admin_lname: '',
            admin_email: '',
            admin_title: '',
            is_enabled: 0,
            is_news: 0,
            is_billingadmin: 0,
            is_primaryadmin: 0,
            id_number: '',
            password: '',
            mobile: '',
            phone: '',
            phone_ext: '',
            location_name: '',
            country: '',
            address: '',
            address2: '',
            city: '',
            zip: '',
            state: '',
            state_options: [
              { value: '', text: 'Select State' },
            ],
            market_area: '',
            remove_flag: false,
            last_login: '',
            no_login: '',
            admin_status: '',
          });
        },
        deleteAdminAction: function(index) {
          if(this.admin_contacts[index].uid == 0) {
            this.admin_contacts.splice(index, 1);
          }
          else {
            /* Soft Delete */
            axios('/user/' + this.admin_contacts[index].uid + '/' + this.accountId,
               {
                 method: 'DELETE',
               }
             )
            .then((resp) => {
                this.updated_admin_contacts = {};
                this.getAdminListData();
            })
            .catch(error => {

            });
          }
        },
        removeAdmin: function(index) {
          this.remove_data = this.admin_contacts[index];
          if((this.remove_data.is_primaryadmin != 1) && (this.remove_data.is_billingadmin != 1)) {
            this.isDeleteModalVisible = true;
            this.delete_id = index;
          }
          else {
            if((this.remove_data.is_primaryadmin == 1) || (this.remove_data.is_billingadmin == 1)) {
              this.validationMessage = "You cannot delete a billing or primary admin.";
            }
            this.isInfoModalVisible = true;
            return false;
          }
        },
        adminPhoneValid: function(event, index) {
          var phone_val = this.admin_contacts[index].phone;
          this.admin_contacts[index].phone = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        adminMobileValid: function(event, index) {
          var phone_val = this.admin_contacts[index].mobile;
          this.admin_contacts[index].mobile = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        adminPhoneExtValid: function(event, index) {
          var phone_val = this.admin_contacts[index].phone_ext;
          this.admin_contacts[index].phone_ext = phone_val.replace(/[^0-9]/g, '');
        },
        updateCountryUS: function(index) {
          this.updateAdminContactEvent(index, 'country', 'US');
          this.updateAdminContactEvent(index, 'state', '');
          this.admin_contacts[index].country = 'US';
          this.getStateLists(this.admin_contacts[index].country, index);
        },
        adminPhoneRegex: function() {
          return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        adminPostalCodeRegex: function(index) {
          if (this.admin_contacts[index].country == "US") {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
          } else if (this.admin_contacts[index].country == "CA") {
            return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
          }
          return /./;
        },
        getCountryLists: function () {
          axios.get('/get-country-lists', {

          })
          .then(response =>  {
            this.country_options = response.data;
          })
          .catch(function(error) {

          });
        },
        getStateLists: function (CountryCode, index) {
          this.updateAdminContactEvent(index, 'state', '');
          this.admin_contacts[index].state = '';
          this.admin_contacts[index].state_options = [
            { value: '', text: 'Select State' },
          ];
          if(CountryCode == '') {
            CountryCode = null;
          }
          axios.get('/get-state-lists/' + CountryCode, {

          })
          .then(response =>  {
            this.admin_contacts[index].state_options = response.data;
          })
          .catch(function(error) {

          });
        },
        clickPrimaryAdmin: function(index) {
          for(var i=0; i < this.admin_contacts.length; i++) {
            this.updateAdminContactEvent(i, 'is_primaryadmin', false);
            this.admin_contacts[i].is_primaryadmin = 0;
          }
          this.updateAdminContactEvent(index, 'is_primaryadmin', true);
          this.admin_contacts[index].is_primaryadmin = 1;
        },
        clickBillingAdmin: function(index) {
          for(var i=0; i < this.admin_contacts.length; i++) {
            this.updateAdminContactEvent(i, 'is_billing', false);
            this.admin_contacts[i].is_billingadmin = 0;
          }
          this.updateAdminContactEvent(index, 'is_billing', true);
          this.admin_contacts[index].is_billingadmin = 1;
        },
        updateAdminContactEvent: function(index, field, value) {
          if(this.admin_contacts[index].uid > 0) {
            if(this.updated_admin_contacts[index]) {
              Vue.set(this.updated_admin_contacts[index], field, value);
            }
            else {
              this.updated_admin_contacts[index] = {};
              Vue.set(this.updated_admin_contacts[index], 'uid', this.admin_contacts[index].uid);
              Vue.set(this.updated_admin_contacts[index], field, value);
            }
          }
        },
        getAdminListData: function() {
          axios("/enterprise_lookup_admin_list", {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          })
          .then(response => {
            this.loading = false;
            this.admin_contacts = response.data;
            this.updated_admin_contacts = {};
          })
          .catch(error => {
            this.loading = false;
          });
        },
        addEvent ({ type, target }) {
          var regex1 = /\d+/g;
          var regex = /\[([0-9]+)\]/g;
          var name = target.name;
          var matches1 = name.match(regex);
          var val = matches1[0];
          var matches = val.match(regex1);
          if(this.admin_contacts[matches].uid > 0) {
            var value;
            if((target.type == 'checkbox') || (target.type == 'radio')) {
              value = target.checked;
            }
            else {
              value = target.value;
            }
            var field = name.replace("["+matches+"]", "");
            this.updateAdminContactEvent(matches, field, value);
          }
        },
        enterSearchAction: function(rowNo) {
          if (!rowNo)
            this.$parent.searchAction();
        },
        openContactModal: function(index) {
          this.isContactModalVisible = true;
          const vmessage = 'hide_vmessage';
          this.$refs.admin_contact_form.getAdminDetail(this.admin_contacts[index], vmessage);
        },
        captureMultiselectModificationAction(index, field, value) {
          this.updateAdminContactEvent(index, field, value);
        },
      },
      created: function () {
        setTimeout(() => {
          this.admin_contacts.push({
            uid: 0,
            admin_fname: this.$store.getters.getSearchEnterprise.admin_fname ?  this.$store.getters.getSearchEnterprise.admin_fname : '',
            admin_lname: this.$store.getters.getSearchEnterprise.admin_lname ?  this.$store.getters.getSearchEnterprise.admin_lname : '',
            admin_email: this.$store.getters.getSearchEnterprise.admin_email ?  this.$store.getters.getSearchEnterprise.admin_email : '',
            admin_title: this.$store.getters.getSearchEnterprise.admin_title ?  this.$store.getters.getSearchEnterprise.admin_title : '',
            is_enabled: 0,
            is_news: 0,
            is_billingadmin: 1,
            is_primaryadmin: 1,
            id_number: '',
            password: '',
            mobile: '',
            phone: '',
            phone_ext: '',
            location_name: '',
            country: '',
            address: '',
            address2: '',
            city: '',
            zip: '',
            state: '',
            state_options: [
              { value: '', text: 'Select State' },
            ],
            market_area: '',
            remove_flag: false,
            last_login: '',
            no_login: '',
            admin_status: '',
          });
          this.getCountryLists();
          if(this.accountId > 0) {
            this.loading = true;
            this.getAdminListData();
          }
        }, 1500);
      },
      mounted() {
        EventBus.$on('VeeValidate', () => {
          this.$validator.validateAll();
        });
      },
    }
</script>
<style scoped>
.admin_heading_1 {  width: 3%; }
.admin_heading_2 {  width: 15%; }
.admin_heading_3 {  width: 15%; }
.admin_heading_4 {  width: 19%; }
.admin_heading_5 {  width: 10%; }
.admin_heading_6 {  width: 7%; }
.admin_heading_7 {  width: 10%; }
.admin_heading_8 {  width: 5%; }
.admin_heading_9 {  width: 5%; }
.admin_heading_10 {  width: 6%; }
.admin_heading_11 {  width: 5%; }
.admin_heading_email { width: 16% }
.admin_heading_contact { width: 10% }
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  min-height: 38px;
}
.ma-blue-btn, .ma-blue-btn:focus, .ma-blue-btn:active, .ma-blue-btn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 36px;
  margin-top: -5px;
}

.admin_heading_1 a {
  color: #707070;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_admin_tab.vue